const sectionAsideQuery = ".section__aside";
const isSetupClass = "section__aside--isSetup";
const disableStickyClass = "section__aside--disableSticky";
const margin = 20;
const asideElements: HTMLElement[] = [];
let resizeListenerSetup = false;




const debounce = (func: Function, wait: number) => {
	let timeout: number;
	return (...args: any[]) => {
		clearTimeout(timeout);
		timeout = window.setTimeout(() => func.apply(this, args), wait);
	};
};

const setupResizeListener = () => {
	if (!resizeListenerSetup) {
		resizeListenerSetup = true;
		window.addEventListener("resize", debounce(checkAllHeights, 100));
	}
};

const checkAllHeights = () => {
	asideElements.forEach((element, index) => {
		if (document.body.contains(element)) {
			if (element.offsetHeight + margin * 2 > document.documentElement.clientHeight) {
				element.classList.add(disableStickyClass);
			} else {
				element.classList.remove(disableStickyClass);
			}
		} else {
			asideElements.splice(index, 1); // Remove element from array if it's no longer in the DOM
		}
	});
};

const setupAside = (element: HTMLElement) => {
	if (element.classList.contains(isSetupClass)) {
		return;
	}
	element.classList.add(isSetupClass);
	asideElements.push(element);
	setupResizeListener();
	checkAllHeights();
};

const SectionAside = () => {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node instanceof HTMLElement && node.matches(sectionAsideQuery)) {
					setupAside(node);
				}
			});
			mutation.removedNodes.forEach((node) => {
				if (node instanceof HTMLElement && node.matches(sectionAsideQuery)) {
					const index = asideElements.indexOf(node);
					if (index > -1) {
						asideElements.splice(index, 1);
					}
				}
			});
		});
	});

	observer.observe(document.body, { childList: true, subtree: true });

	document.querySelectorAll<HTMLElement>(sectionAsideQuery).forEach(setupAside);
};

export default SectionAside;
